import { useEffect, useRef } from "react";
import { useBeforeUnload } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resetAllMealsToShow } from "Redux/slices/selectedMealsSlice";
import { useUserData } from "context/OAuth/AuthContext";

export function NavigationPrompt({ when, mealSelection = false }) {
  const dispatch = useDispatch();
  const { language } = useUserData();
  const languageChangeInProgress = useRef(false);

  // BeforeUnload handler (refresh / tab close)
  useBeforeUnload((e) => {
    if (
      when &&
      !sessionStorage.getItem("forceReload") &&
      !languageChangeInProgress.current
    ) {
      e.preventDefault();
      e.returnValue =
        "You have unsaved changes. Are you sure you want to leave?";
    }
  });

  // Mark language change in progress
  useEffect(() => {
    languageChangeInProgress.current = true;

    const timer = setTimeout(() => {
      languageChangeInProgress.current = false;
    }, 100);

    return () => clearTimeout(timer);
  }, [language]);

  // Handle navigation attempts
  useEffect(() => {
    if (!when) return;

    const handleClick = (e) => {
      if (sessionStorage.getItem("forceReload") || languageChangeInProgress.current) return;

      if (e.target.tagName === "A" || e.target.closest("a")) {
        const confirmed = window.confirm(
          "You have changes in progress. Are you sure you want to leave?"
        );
        if (!confirmed) {
          e.preventDefault();
          e.stopPropagation();
        } else if (mealSelection) {
          dispatch(resetAllMealsToShow());
        }
      }
    };

    const handlePopState = () => {
      if (sessionStorage.getItem("forceReload") || languageChangeInProgress.current) return;

      const confirmed = window.confirm(
        "You have unsaved changes. Are you sure you want to leave?"
      );
      if (!confirmed) {
        window.history.pushState(null, "", window.location.pathname);
      } else if (mealSelection) {
        dispatch(resetAllMealsToShow());
      }
    };

    window.history.pushState(null, "", window.location.pathname);
    window.addEventListener("click", handleClick, true);
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("click", handleClick, true);
      window.removeEventListener("popstate", handlePopState);

      if (window.history.state === null) {
        window.history.back();
      }
      sessionStorage.removeItem("forceReload");
    };
  }, [when, mealSelection, dispatch]);

  return null;
}
